module.exports = __webpack_public_path__ + "static/media/15.89ea8126.jpg";